import { ADD_SPECIALITY } from '../actions/types';
import {
  FETCH_SPECIALITIES_REQUEST,
  FETCH_SPECIALITIES_SUCCESS,
  FETCH_SPECIALITIES_FAILURE,
  SPECIALITY_UPDATE_FAIL,
  SPECIALITY_UPDATE_SUCCESS
} from '../actions/types';

const initialState = {
  loading: false,
  specialities: [],
  error: null,
};

const specialityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SPECIALITIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SPECIALITIES_SUCCESS:
      // console.log(action.payload);
      return {
        ...state,
        loading: false,
        specialities: action.payload,
      };
    case FETCH_SPECIALITIES_FAILURE:
      return {

        ...state,
        loading: false,
        error: action.error,
      };
    case ADD_SPECIALITY:
      return {
        ...state,
        specialities: [...state.specialities, action.payload],
      };
      case SPECIALITY_UPDATE_SUCCESS:
  if (!action.payload || !action.payload.data || !action.payload.data.id) {
    console.error('Invalid payload in SPECIALITY_UPDATE_SUCCESS:', action.payload);
    return state;
  }

  return {
    ...state,
    specialities: state.specialities.map((spec) =>
      spec.id === action.payload.data.id ? action.payload.data : spec
    ),
  };

    case SPECIALITY_UPDATE_FAIL:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default specialityReducer;
